



























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import TableSelect from '@/modules/common/tes-table/components/shared/TableSelect.vue'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import { ContentCampaignResourceTypeInAdmin } from '@/modules/content-campaign/models/content-campaign-resource.model'
import { ContentItemStatus } from '@/modules/content-item/models/content-item-resource.model'
import { getContentItemColumnsInAdmin } from '@/modules/content-item/models/columns/content-item.column'
import AdminContentCampaignItemsTableRow
  from '@/modules/content-campaign/components/admin/table/AdminContentCampaignItemsTableRow.vue'

@Component({
  components: {
    TesTable,
    TableSelect
  }
})
export default class AdminContentCampaignItemsTable extends Vue {
  @ProvideReactive()
  @Prop({ required: true }) contentCampaign!: ContentCampaignResourceTypeInAdmin

  private columns = getContentItemColumnsInAdmin().filter(col => col.field !== 'user')

  private rowComponent = AdminContentCampaignItemsTableRow

  private activeTab = 'total'

  private get contentItems(): ContentCampaignResourceTypeInAdmin['data']['items'] {
    return this.contentCampaign.data.items
  }

  private get contentItemStatuses(): ContentCampaignResourceTypeInAdmin['item_statuses'] {
    return this.contentCampaign.item_statuses
  }

  private get contentItemsCount(): ContentCampaignResourceTypeInAdmin['data']['items_count'] {
    return this.contentCampaign.data.items_count
  }

  private get tabs() {
    const tabsIcon = {
      total: 'ion list-outline',
      [ContentItemStatus.PENDING]: 'pending_actions',
      [ContentItemStatus.QUEUE]: 'playlist_add_check',
      [ContentItemStatus.WAITING_PAYMENT]: 'credit_card',
      [ContentItemStatus.EDITING]: 'drive_file_rename_outline',
      [ContentItemStatus.REVIEW]: 'published_with_changes',
      [ContentItemStatus.COMPLETED]: 'task',
      [ContentItemStatus.REJECTED]: 'close',
      [ContentItemStatus.CANCELLED]: 'do_not_disturb'
    }

    const tabs = [{
      name: 'total',
      icon: tabsIcon.total,
      label: 'همه ایتم ها',
      reverse: true,
      count: this.contentCampaign.data.total_items_count
    }]

    return tabs.concat(
      Object.entries(this.contentItemsCount).map(([key, value]) => ({
        name: key,
        icon: tabsIcon[key],
        label: this.contentItemStatuses[key],
        count: value,
        reverse: false
      }))
    )
  }

  private get filterItems() {
    if (this.activeTab === 'total') return this.contentItems

    return this.contentItems.filter(item => item.status === this.activeTab)
  }
}
